/* global BigInt */
import { validCents } from './cashMoney';
import { CATEGORY_FAMILIES, validCategoryRates } from '../../services/categoryPricing';

export const CREDIT_CATEGORIES = CATEGORY_FAMILIES.map((category) => category.familyKey);
export const categoryLabel = (key) =>
  ({ membrane_wrap: 'Membrane Wrap', membrane_wrap_lite: 'Membrane Wrap Lite' })[key];

const unconfiguredPrices = (row) =>
  row.pricingBasis === undefined &&
  row.categoryRates === undefined &&
  Array.isArray(row.productRates) &&
  row.productRates.length === 0;

// Category prices are USD cents per physical piece. Legacy unit rates are never inputs.
export const validCalculatorSettings = (row) =>
  row?.schemaVersion === 1 &&
  row.currency === 'USD' &&
  /^[a-f\d]{24}$/.test(row.distributorId) &&
  typeof row.enabled === 'boolean' &&
  validCents(row.revision) &&
  ((row.pricingBasis === 'piece' && validCategoryRates(row.categoryRates)) ||
    unconfiguredPrices(row)) &&
  Array.isArray(row.shippingRanges) &&
  new Set(row.shippingRanges.map((range) => range.shippingSpeed)).size ===
    row.shippingRanges.length &&
  row.shippingRanges.every(
    (range) =>
      typeof range.shippingSpeed === 'string' &&
      validCents(range.minCents) &&
      validCents(range.maxCents) &&
      range.minCents <= range.maxCents &&
      range.maxCents <= 1000000
  );

export function affordablePieces(balanceCents, pricePerPieceCents, shippingCents) {
  if (![balanceCents, pricePerPieceCents, shippingCents].every(validCents) || !pricePerPieceCents)
    return null;
  if (shippingCents >= balanceCents) return 0;
  return Number(BigInt(balanceCents - shippingCents) / BigInt(pricePerPieceCents));
}
